import { Routes, Route } from "react-router-dom";
import FrontOfficeLayout from "./FrontOfficeLayout";
import FrontOfficeDashboard from "../../Pages/FrontOffice/FrontOfficeDashboard";
import AddFrontLead from "../../Pages/FrontOffice/AddFrontLead";
import FrontOfficeLead from "../../Pages/FrontOffice/FrontOfficeLead";
import ErrorPage from "../../ErrorPage";


const FrontOfficeRoute = () => {
  return (
    <FrontOfficeLayout>
      <Routes>
         <Route path="dashboard" element={<FrontOfficeDashboard/>} />
         <Route path="lead-management/add" element={<AddFrontLead/>} />
        <Route path="lead-management/view" element={<FrontOfficeLead/>} />
        <Route path="*" element={<ErrorPage />} />
        {/* Add more super admin pages here */}
      </Routes>
    </FrontOfficeLayout>
  );
};

export default FrontOfficeRoute;
